import styled from "@emotion/styled";

import { AdSlotContainer } from "~/components/advertisement/ad-slots/ad-slot/styles";
import type { WithStickyStackedHeightProps } from "~/lib/styles";

export const Right = styled.div`
  display: none;

  > * + * {
    margin-block-start: 40px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    display: flex;
    flex-flow: column nowrap;
  }
`;

export const DesktopRightSectionAdSlot = styled.div`
  display: none;
  ${props => props.theme.breakpoints.up("desktop")} {
    display: block;
  }

  && ${AdSlotContainer} {
    align-items: flex-start;
  }
`;

export const RightSection = styled.div`
  flex: auto;
`;

export const RightSectionSticky = styled.div<WithStickyStackedHeightProps>`
  position: sticky;
  inset-block-start: ${props => props.$stickyStackedHeight + 50}px;
  > * + * {
    margin-block-start: 40px;
  }
`;

export const NewsletterWidgetContainer = styled.div`
  padding-block: 16px;
  padding-inline: 0;

  border: 1px solid #d8d8d8;
  border-width: 1px 0;
`;
